module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-3-svgrepo-com.f49e4cea.svg";